import _ from 'lodash'
import * as configs from './index'
import { subForms } from '../constants'
import { dataFunctions } from '../helpers'

export const subFormsDispatcher = ({ sectionPath, ...props }) => {
  const configName = _.get(
    subForms,
    `[${_.findIndex(subForms, ['path', sectionPath])}].configName`
  )

  const forms = configs[configName].getSubForms(props)

  return forms
}

export const getConfig = (sectionPath, commonValueTable) => {
  const subForm = _.get(
    subForms,
    `[${_.findIndex(subForms, ['path', sectionPath])}]`
  )
  const configName = subForm.configName
  const ALT_PATH = subForm.alternatePath

  const { valueTable } = configs[configName]
  const views = configs[configName].views
  const columns = configs[configName].columns
  const defaultSorting = configs[configName].defaultSorting
  const defaultNew = configs[configName].defaultNew
  const active = configs[configName].activeSection
  const modified = configs[configName].modified
  const errors = configs[configName].errors

  return {
    valueTable: { ...valueTable, ...commonValueTable },
    views,
    columns,
    defaultSorting,
    defaultNew,
    active,
    modified,
    errors,
    subFormDetails: { ...subForm },
    ALT_PATH
  }
}

export const getDataFunctions = sectionPath => {
  const functionName = _.get(
    subForms,
    `[${_.findIndex(subForms, ['path', sectionPath])}].dataFunctionName`
  )

  const getData = dataFunctions[functionName]

  return getData
}



// WEBPACK FOOTER //
// ./src/personnel/configs/subformConfig.js